import React from "react";
import { List, TextInput, SelectMenu } from "@raketa-cms/raketa-cms";
import InputSection from "../common/InputSection";
import TooltipInput from "../common/TooltipInput";
import RatePlanInput from "../common/RatePlanInput";

const LICENSE_TEMPLATE = {
  license_type: "Fixed license",
  default_license: "no",
  tooltip: TooltipInput.defaults,
  monthly: { ...RatePlanInput.defaults, after_price: "/month" },
  annual: { ...RatePlanInput.defaults, after_price: "/year" },
  triennial: { ...RatePlanInput.defaults, after_price: "/3 years" },
};

const RatePlansInput = ({ settings, onChangeItem }) => {
  return (
    <React.Fragment>
      <TextInput
        label="License type"
        value={settings.license_type}
        onChange={(value) => onChangeItem("license_type", value)}
      />

      <SelectMenu
        label="Default license"
        options={[
          ["yes", "Yes"],
          ["no", "No"],
        ]}
        value={settings.default_license}
        onChange={(value) => onChangeItem("default_license", value)}
      />

      <InputSection title="Tooltip">
        <TooltipInput
          value={settings.tooltip || {}}
          onChange={(value) => onChangeItem("tooltip", value)}
        />
      </InputSection>

      <RatePlanInput
        label="Monthly rate plan ID"
        value={settings.monthly || {}}
        onChange={(value) => onChangeItem("monthly", value)}
      />

      <RatePlanInput
        label="Annual rate plan ID"
        value={settings.annual || {}}
        onChange={(value) => onChangeItem("annual", value)}
      />

      <RatePlanInput
        label="3 year rate plan ID"
        value={settings.triennial || {}}
        onChange={(value) => onChangeItem("triennial", value)}
      />
    </React.Fragment>
  );
};

const LicensesInput = ({ value, onChange }) => {
  return (
    <List
      label="Rate plans"
      listItem={(settings, onChangeItem) => (
        <RatePlansInput settings={settings} onChangeItem={onChangeItem} />
      )}
      items={value}
      template={LICENSE_TEMPLATE}
      primaryField="license_type"
      onChangeList={(_list, newList) => onChange(newList)}
    />
  );
};

export default LicensesInput;
